import React, { useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import { useCalculator } from '../context/CalculatorContext';

/**
 * CalculatorWrapper - Exposes calculator context API to parent components via ref
 * @param {Object} props - Component props
 * @param {React.Ref} props.calculatorRef - Ref receiving useCalculator() value
 * @returns {null} Renders nothing
 */
const CalculatorWrapper = ({ calculatorRef }) => {
  const calculator = useCalculator();

  useImperativeHandle(calculatorRef, () => calculator, [calculator]);

  return null;
};

CalculatorWrapper.propTypes = {
  calculatorRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]).isRequired,
};

export default CalculatorWrapper;
